import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { jqxBarGaugeComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxbargauge';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { EMPTY, Observable, Subject, timer } from 'rxjs';
import { catchError, take, tap } from 'rxjs/operators';

import { Provimento } from '../_classes/provimento';
import { Servidor } from '../_classes/servidor';
import { RestService } from '../_servicos/rest.service';
import { ServidorService } from '../_servicos/servidor.service';
import { ModalAlertaService } from '../shared/modal-alerta.service';
import { PeriodoAvaliativo } from './../_classes/periodo-avaliativo';
import { Util } from './../_classes/util';
import { EnvService } from '../_servicos/env.service';

class Nota {
  id: number;
  periodo: string;
  nota: number;
  constructor(d?) {
    this.id = d.id ? d.id : null;
    this.periodo = d.periodo ? d.periodo : null;
    this.nota = d.nota ? d.nota : null;
  }
}

@Component({
  selector: 'app-avaliacao-gauge',
  templateUrl: './avaliacao-gauge.component.html',
  styleUrls: ['./avaliacao-gauge.component.scss'],
})
export class AvaliacaoGaugeComponent implements OnInit {
  @ViewChild('myBarGauge', { static: true }) myBarGauge: jqxBarGaugeComponent;

  displayedColumns: string[] = [
    'dtIniPeriodo',
    'avaliacao.dtLimiteAvaliacao',
    'avaliacao.avaliador',
    'avaliacao.nrNotaFinal',
    'docs',
  ];

  carregando = false;

  servidor$: Observable<Servidor>;
  servidor: Servidor = new Servidor();

  erros$ = new Subject<boolean>();
  dataSource$: Observable<Provimento[]>;
  dataSource: MatTableDataSource<Provimento>;

  modalRef: BsModalRef;
  config = {
    keyboard: true,
    class: 'modal-lg',
  };

  mostrarAjuda = false;
  itensAjuda = [
    { titulo: 'Período', texto: '' },
    { titulo: 'Situação', texto: 'xxx' },
    { titulo: 'Local', texto: 'xxx' },
    { titulo: 'Formato', texto: 'xxx' },
    { titulo: 'Avaliador', texto: 'xxx' },
    { titulo: 'Nota', texto: 'xxx' },
    { titulo: 'Documentos', texto: 'xxx' },
  ];

  valores: Nota[] = [];
  valoresMatriz: [];

  source: any = {
    datatype: 'json',
    datafields: [{ name: 'periodo' }, { name: 'nota', type: 'int' }],
    id: 'id',
    localdata: this.valores,
  };

  dataAdapter: any = new jqx.dataAdapter(this.source);

  tooltip: any = {
    visible: true,
    formatFunction: (value: string, index: number) => {
      let items = this.valores;
      let item = items[index];
      return item.periodo + ': ' + item.nota;
      //return ' cal1';
    },
  };

  labels: any = {
    formatFunction: (value: any) => {
      return value;
    },
    precision: 0,
    indent: 5,
    connectorWidth: 1,
  };

  private t: any;

  ngOnDestroy() {
    if (this.t) {
      this.t.unsubscribe();
    }
  }

  convertToArray(items: Nota[]): number[] {
    let preparedArray = new Array(items.length);
    for (let i = 0; i < items.length; i += 1) {
      preparedArray[i] = items[i].nota;
    }
    return preparedArray;
  }

  geraSoUm(items: Nota[], vI: number): number[] {
    let preparedArray = new Array(items.length);

    for (let i = 0; i < items.length; i += 1) {
      if (i <= vI) {
        preparedArray[i] = items[i].nota;
      } else {
        preparedArray[i] = 0;
      }
    }
    //console.log(preparedArray);
    return preparedArray;
  }

  iniciarGrafico() {
    let items = this.valores;
    let arrayOfItems = this.geraSoUm(items, 0);
    this.myBarGauge.values(arrayOfItems);
  }

  loop: number = -1;
  outroLoop: number = 0;
  onDrawEnd(): void {
    this.loop++;
    //tentei fazer com variáveis mas explode sempre a pilha
    //console.log(this.loop);
    switch (this.loop) {
      case 0:
        this.myBarGauge.values(this.geraSoUm(this.valores, 0));
        break;
      case 1:
        this.myBarGauge.values(this.geraSoUm(this.valores, 1));
        break;
      case 2:
        this.myBarGauge.values(this.geraSoUm(this.valores, 2));
        break;
      case 3:
        this.myBarGauge.values(this.geraSoUm(this.valores, 3));
        break;
      case 4:
        this.myBarGauge.values(this.geraSoUm(this.valores, 4));
        break;

      default:
        //console.log('Render time is finished.');
        break;
    }
  }

  constructor(
    private service: RestService,
    private servService: ServidorService,
    private alertService: ModalAlertaService,
    private env: EnvService
  ) {
    this.dataSource = new MatTableDataSource([]);
  }

  periodo(dI: Date, dF: Date) {
    return Util.periodoMesAbreviado(dI, dF);
  }

  dataStr(d: Date) {
    return Util.dataMesAbrev(d);
  }

  ngOnInit() {
    this.atualizar();
  }

  executarAoCarregarServidor(x: Servidor) {
    this.servidor = new Servidor(x);
  }

  executarAoCarregarPeriodo(x: PeriodoAvaliativo[]) {
    let item: Nota = null;
    this.valores = [];
    x.forEach((e) => {
      if (e.avaliacao) {
        if (e.avaliacao.nrNotaFinal) {
          if (e.avaliacao.nrNotaFinal > 0) {
            item = new Nota({
              id: Math.round(100),
              nota: e.avaliacao.nrNotaFinal,
              periodo: Util.periodoAno(e.dtIniPeriodo, e.dtFimPeriodo),
            });
            this.valores.push(item);
          }
        }
      }
    });
    this.iniciarGrafico();
  }

  executarAoCarregarDatasource(x: Provimento[]) {
    /*x.forEach(item => {
      item.DSPeriodoAvaliativo$ = this.service
        .listarPeriodoAvaliativo(this.servidor.idServidor)
        .pipe(
          tap(a => this.executarAoCarregarPeriodo(a)),
          take(1),
          catchError(e => {
            this.handleError(e);
            return empty();
          })
        );
    });
*/
    this.dataSource = new MatTableDataSource<Provimento>(x);

    this.carregando = false;
  }

  atualizar() {
    this.carregando = true;
    this.t = timer(20000).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
        this.handleError(
          'Excedido tempo de carregamento (' + this.constructor.name + ')'
        );
      }
    });

    this.servidor = this.env.servidor; //      this.servService.getServidorAtualRedirecionando('avaliacao-gauge');

    this.servidor$ = this.servService.getServidor().pipe(
      tap((x) => this.executarAoCarregarServidor(x)),
      take(1),
      catchError((e) => {
        this.handleError(e);
        return EMPTY;
      })
    );

    if (this.servidor) {
      this.dataSource$ = this.service
        .listarProvimento(this.servidor.idServidor)
        .pipe(
          tap((a) => this.executarAoCarregarDatasource(a)),
          take(1),
          catchError((e) => {
            this.handleError(e);
            return EMPTY;
          })
        );
    }
  }
  aplicarFiltro(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  alterarMostrarAjuda() {
    this.mostrarAjuda = !this.mostrarAjuda;
  }

  handleError(e: any) {
    this.erros$.next(true);
    this.alertService.mostrarAlertaPerigo(
      'Erro, tente novamente mais tarde',
      e
    );
  }
}
